import { useContext } from 'react';
import { Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MeContext } from '../../../context/MeContext';
import { MeContextState } from '../../../store/types/account';

export const useIsLegacyBilling = () => {
  const { state } = useContext(MeContext) as { state: MeContextState };
  return state.billingEnabled === false;
};

const PlanUpgradeButton = () => {
  const isLegacyBilling = useIsLegacyBilling();

  if (isLegacyBilling) {
    return (
      <Button as="a" href="mailto:sales@passentry.com" size="sm" width="full">
        Contact sales
      </Button>
    );
  }

  return (
    <Button as={RouterLink} to="/subscription" size="sm" width="full">
      Upgrade Plan
    </Button>
  );
};

export default PlanUpgradeButton;
